
export default {
  name: 'WrapContent',
  props: {
    // PC端最小边距
    // 移动端上边距
    mTop: {
      type: String,
      default: '80px',
    },
    title: {
      type: String,
      default: '标题',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    // 标题的左中右布局
    titleAlign: {
      type: String,
      default: 'left',
    },
  },
  data() {
    return {}
  },
}
